export const GLOBAL_SEARCH_PANEL_TEXT = {
  label: '검색 결과',
  guide: [
    '* 2글자 이상의 검색어를 입력해주세요',
    '* 검색어/회사명 형식으로 검색시 특정 기업 내 정보를 검색합니다.\n  예시) "재무제표/부분회수 케이스 A"',
    '* "/" 기호 없이 검색어만 입력 시 모든 기업 내 정보를 검색합니다.',
  ],
  quoted: (text: string) => `"${text}"`,
  inCompany: '기업 내',
  result: '검색 결과',
  loading: '검색 중...',
  empty: '검색 결과가 없습니다.',
} as const;
